import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getContestData } from '../services/contestService';
import {useLang} from "../context/LanguageContext";
import Loading from "../components/Loading";
import BackButton from "../components/BackButton";
import ExternLinkCard from "../components/mainCards/ExternLinkCard";
import tikTokAnimation from '../lotties/tiktok.json';
import Footer from "../components/Footer";


const ContestPage = () => {
    const navigate = useNavigate();
    const [urlVideo, setUrlVideo] = useState('');
    const [urlTicket, setUrlTicket] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const {language, t} = useLang();


    useEffect(() => {
        getContestData(language)
            .then((data) => {
                setUrlTicket(data.urlTicket);
                setUrlVideo(data.urlVideo);
                setLoading(false);
            })
            .catch((err) => {
                setError("Failed to load contest.");
                setLoading(false);
            });
    }, [language]);

    if (loading) {
        return (
            <Loading />
        );
    }

    if (error) {
        return (
            <div className="bg-gray-100 min-h-screen p-5 flex flex-col">
                <button
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 bg-gray-300 rounded mb-5 self-start"
                >
                    {t('btn.back')}
                </button>
                <div className="text-red-500">{error}</div>
            </div>
        );
    }

    return (
        <div className="relative bg-gray-100 min-h-screen p-5">
            <BackButton onClick={() => navigate('/')}/>
            <h1 className="text-xl font-bold text-center mt-16 mb-4">
                {t('txt.contestTitle')}
            </h1>
            <h2 className="text-l font-bold text-center my-4">
                {t('txt.contestDescription')}
            </h2>
            <div className="space-y-4">
                <img src={urlTicket}  alt={t('txt.contestTitle')}/>
                <ExternLinkCard
                    url={urlVideo}
                    animation={tikTokAnimation}
                    title={t('btn.applyToContest')}
                />
            </div>
            <Footer />
        </div>
    );
};

export default ContestPage;
